
export enum QueryOperand {
    '==' = 0,
    '!=' = 1,
    'lk' = 2,
    '!lk' = 3,
    '>' = 4,
    '<' = 5,
    '>=' = 6,
    '<=' = 7
}
